<template>
	<div>
		<b-row>
			<b-col md="12" class="mb-4">
				<h6>Null</h6>
				<osym-quota-selectbox v-model="value1"/>
				<span>{{ value1 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Single Selected</h6>
				<osym-quota-selectbox v-model="value2"/>
				<span>{{ value2 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Validate Error</h6>
				<osym-quota-selectbox v-model="value3" :validateError="value3ValidateError"/>
				<span>{{ value3 }}</span>
			</b-col>
			<b-col cols="12">
				<b-button variant="primary" @click="change()">
					{{ $t('change').toUpper() }}
				</b-button>
			</b-col>
		</b-row>
	</div>
</template>
<script>
	import OsymQuotaSelectbox from "@/components/interactive-fields/OsymQuotaSelectbox";

	export default {
		components: {
			OsymQuotaSelectbox,
		},
		data() {
			return {
				value1: null,
				value2: 200500008,
				value3: 200500008,
				value3ValidateError: 'Validate Error is Working',
			}
		},
		methods: {
			change() {
				this.value2 = 200500013
				this.value3 = 200500013
				this.value3ValidateError = 'Error'
			}
		}
	};
</script>

